import Toast, {
  SuccessToast,
  ErrorToast,
  ToastProps,
  InfoToast,
} from "react-native-toast-message";
import React from "react";
import { Entypo } from "@expo/vector-icons";
import "./toast.css";

const TrailingIcon = () => (
  <Entypo
    name="cross"
    size={24}
    color="black"
    onPress={() => Toast.hide()}
    style={{ alignSelf: "center", marginRight: 5 }}
  />
);
// overwriting react-native-toast-message styles
export default {
  success: (props: ToastProps) => (
    <SuccessToast
      {...props}
      text1NumberOfLines={99}
      style={{
        borderLeftColor: "rgb(0, 200, 81)",
        height: "auto",
        minHeight: 60,
      }}
      renderTrailingIcon={TrailingIcon}
    />
  ),
  error: (props: ToastProps) => (
    <ErrorToast
      {...props}
      text1NumberOfLines={99}
      style={{
        borderLeftColor: "rgb(255, 68, 68)",
        height: "auto",
        minHeight: 60,
      }}
      renderTrailingIcon={TrailingIcon}
    />
  ),

  info: (props: ToastProps) => (
    <InfoToast
      {...props}
      text1NumberOfLines={99}
      style={{
        borderLeftColor: "rgb(51, 181, 229)",
        height: "auto",
        minHeight: 60,
      }}
      renderTrailingIcon={TrailingIcon}
    />
  ),

  warning: (props: ToastProps) => (
    <ErrorToast
      {...props}
      text1NumberOfLines={99}
      style={{
        borderLeftColor: "rgb(255, 187, 51)",
        height: "auto",
        minHeight: 60,
      }}
      renderTrailingIcon={TrailingIcon}
    />
  ),
};
